import { render, staticRenderFns } from "./Unidadesdel.vue?vue&type=template&id=0e12b724"
import script from "./Unidadesdel.vue?vue&type=script&lang=js"
export * from "./Unidadesdel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports